module.exports = __webpack_public_path__ + "img/9791186490228.6fa160bd.jpg";